import { useMemo } from 'react';

/**
 * Hook to get user permissions from localStorage
 * Returns permission check functions and permission flags
 */
const usePermissions = () => {
  const permissions = useMemo(() => {
    try {
      const storedUser = localStorage.getItem('user');
      if (!storedUser) return null;
      
      const parsedUser = JSON.parse(storedUser);
      return parsedUser?.role?.permissions || null;
    } catch (error) {
      console.error('Error parsing user permissions:', error);
      return null;
    }
  }, []);

  // Helper function to check a permission (defaults to true if permission not found)
  const hasPermission = (key) => {
    // If no structured permissions object, treat as legacy user with full access
    if (!permissions || typeof permissions !== 'object') return true;

    return Object.prototype.hasOwnProperty.call(permissions, key)
      ? !!permissions[key]
      : false;
  };

  return {
    permissions,
    hasPermission,
    // Convenience getters for common permissions
    canViewPrices: hasPermission('viewPrices'),
    canCreateSalesOrders: hasPermission('createSalesOrders'),
    canViewDashboard: hasPermission('dashboard'),
    canViewItems: hasPermission('items'),
    canViewAllOrders: hasPermission('allOrders'),
    canViewOrderedItems: hasPermission('viewOrderedItems'),
    canViewMyAccount: hasPermission('myAccount'),
    canViewRolesAndPermissions: hasPermission('rolesAndPermissions'),
    canManageItems: hasPermission('manageItems'),
    canViewUserManagement: hasPermission('userManagement'),
    canViewAllUsers: hasPermission('allUsers'),
  };
};

export default usePermissions;
